import { call, put, select, takeLatest } from 'redux-saga/effects'

import { SWITCH_ORGANIZATION } from '../actions'
import { actions } from '../api'
import { API_BASE, changeCurrentOrganizationKey } from '../callApi'

import { getCSRFTokenFromCookie } from '../utils/getCSRFTokenFromCookie'
import {
  SessionSagaReturnType,
  SwitchOrganizationActionT,
  isLoggedInSessionState,
} from '../../types'

export function* triggerOrganizationSwitchSideEffects(
  action: SwitchOrganizationActionT
): SessionSagaReturnType {
  const { newOrganization } = action.payload

  // wipe all kraken caches
  // @ts-ignore TODO:SIGPG-3011 WipeAction is not part of the session actions
  yield put(actions.wipe())

  const session = yield select(({ session }) => session)

  if (!isLoggedInSessionState(session)) {
    return
  }

  // @ts-ignore TODO:SIGPG-3011 AddMetadata is not part of the session actions
  yield put(
    actions.addMetaData({
      headers: {
        Authorization: session.token,
        'X-CSRF-TOKEN': getCSRFTokenFromCookie(),
      },

      apiBase: `${API_BASE}/${newOrganization.key}`,
    })
  )

  // the logout method needs to be called that way to use the correct context
  yield call(changeCurrentOrganizationKey, newOrganization.key)
}

export default function* watchLogoutActions() {
  yield takeLatest(SWITCH_ORGANIZATION, triggerOrganizationSwitchSideEffects)
}
